// extracted by mini-css-extract-plugin
export default {"wrapper":"lq3j6","image-wrapper":"KdcR7","image":"czpYp","ad":"TuWq6","content":"J81Uc"};